import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConsentBanner } from '../ConsentBanner';
import { Concierge } from '../Concierge';
import { Seo } from '../Seo';
import { AfricanBackdrop } from './AfricanBackdrop';
import { track } from '../../lib/analytics';
import { routeSeo } from '../../data/seoRoutes';
export function SiteLayout() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    track('page_view', {
      path: location.pathname,
      referrer: document.referrer
    });
  }, [location.pathname]);

  // Static routes take their metadata from one map. Routes that depend on the
  // record being shown, articles, resources, service lines and Cavalla Gov,
  // render their own Seo on the page instead, so there is never a moment where
  // two sources compete for the same tags.
  const seo = routeSeo(location.pathname);
  return <div className="flex min-h-screen w-full flex-col bg-charcoal" data-id="element-905" data-mp="1acv7jj27j5wc">
      {seo && <Seo title={seo.title} description={seo.description} path={location.pathname} jsonLd={seo.jsonLd} noIndex={seo.noIndex} data-id="element-906" data-mp="1aar2uywhi2v0" />}
      <AfricanBackdrop data-id="element-907" data-mp="1k4rhbrdnokge" />
      <Header data-id="element-908" data-mp="1o40buygismd0" />
      <main id="main" className="flex-1" data-id="element-909" data-mp="1o4ruz9sxkrme">
        <Outlet data-id="element-910" data-mp="1o3gt5fj1ptxx" />
      </main>
      <Footer data-id="element-911" data-mp="rdzewc5zyzkm" />
      {/* The Academy has its own support chat in the same corner. */}
      {!location.pathname.startsWith('/academy') && <Concierge data-id="element-912" data-mp="wcaqarbxxi4y" />}
      <ConsentBanner data-id="element-913" data-mp="wdvk2eqfkx1r" />
    </div>;
}